
import Avatar, { AvatarProps } from "@mui/material/Avatar";


const FdAvatar = ({...props}: AvatarProps): JSX.Element => {
  return (
      <Avatar {...props} />
  );
};
export default FdAvatar;
